import React from 'react';
import O_TreePost from '../../components/O_Organisms/O_TreePost/O_TreePost';
import styles from './TreeDetailPage.module.css';

export default function TreeDetailPage() {
  return (
    <div className={styles.wrapper}>
      <O_TreePost />
    </div>
  );
}
